<template>
  <div class="notification is-danger is-radiusless" v-if="response">
    <div class="block">
      <div class="columns">
        <div class="column is-3">
          <h1 class="title is-size-1">{{ $t(`Ошибка`) }} {{ response.status }}</h1>
          <p>{{ $t('Запрос не может быть выполнен. Пожалуйста повторите попытку позже.') }}</p>
        </div>
      </div>
    </div>
    <div class="block">
      <button class="ws-button button is-primary" @click="reload">
        <span class="has-text-white">{{ $t('Нажмите здесь чтобы перезагрузить страницу') }}</span>
      </button>
    </div>
    <div class="block" v-if="stage !== 'prod'">
      <p>
        <button class="ws-button button is-text ws-button__toggle has-text-white" @click="toggleDetails">
          <span v-if="!isShownErrorDetails">{{ $t('Показать детали ошибки') }}</span>
          <span v-else>{{ $t('Скрыть детали ошибки') }}</span>
        </button>
      </p>
    </div>
    <div class="block">
      <pre v-if="isShownErrorDetails">{{ response }}</pre>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WsErrorHandler',
  data () {
    return {
      isShownErrorDetails: false,
      stage: __stage
    }
  },
  computed: {
    ...mapState('errors', {
      response: 'errors'
    })
  },
  methods: {
    reload () {
      window.location.reload()
    },
    toggleDetails () {
      this.isShownErrorDetails = !this.isShownErrorDetails
    }
  }
}
</script>

<style scoped>
  pre {
    background: #000;
    color: #999;
  }
  .ws-button__toggle {
    border-bottom: 1px dashed;
  }
</style>
